module.exports = __webpack_public_path__ + "img/block.cf682f53.svg";